<template>
  <tr class="marketing-sms-form-senders-list-item">
    <td class="marketing-sms-form-senders-list-item-checkbox">
      <v-checkbox :input-value="isSelected"
                  @click="checkIfSetSenderType"></v-checkbox>
    </td>
    <td class="marketing-sms-form-senders-list-item-key">
      {{ item.label  }}
    </td>
  </tr>
</template>

<script>
export default {
  components: {},

  data() {
    return {};
  },

  props: {
    item: {
      type: Object,
      required: true,
    },
    selectedItem: {
      type: String,
      required: false,
    },
  },

  methods: {
    checkIfSetSenderType() {
      if (!this.isSelected) {
        this.$emit("selected", this.item.name);
      }
    },
  },

  created() {},

  computed: {
    isSelected() {
      return this.selectedItem === this.item.name;
    },
  },

  mixins: [],
};
</script>

<style lang="scss" scoped>
.marketing-sms-form-senders-list-item {
  .marketing-sms-form-senders-list-item-checkbox {
    padding: 0 0 0 10px !important;

    > div {
      height: 20px;
      margin: 0 !important;
    }
  }

  .marketing-sms-form-senders-list-item-key {
    margin-left: -50px;
  }
}
</style>
